import { connect } from 'react-redux';

import TasksAndChecklists from './TasksAndChecklists';
import { getUserProfileWidget } from '../../selectors/index';

const mapStateToProps = state => {
  return {
    userProfileWidgets: getUserProfileWidget(state)
  };
};

export default connect(mapStateToProps, null)(TasksAndChecklists);
